// extracted by mini-css-extract-plugin
export default {"statusBox":"status_statusBox__rwClf","statusTxt":"status_statusTxt__h1EwW","statusImg":"status_statusImg__Tb9kq"};